export const copyLink = () => {
    return {
        copied: false,
        timeout: null,
        url: () => window.location.href,

        copy() {
            navigator.clipboard
                .writeText(this.url())
                .then(() => {
                    this.copied = true;

                    clearTimeout(this.timeout);
                    this.timeout = setTimeout(() => (this.copied = false), 1500);
                })
                .catch((err) => {
                    console.error('Failed to copy:', err);
                });
        },
    };
};
